module.exports = __webpack_public_path__ + "assets/img/wine-white.c7bd3551.svg";